package `fun`.adaptive.cookbook.support

enum class E {
    V1, V2, V3, V4, V5;
}